<mojo-navbar></mojo-navbar>
<mojo-page-title [title]="title"></mojo-page-title>

<section class="text-center full-page-scrollable">
  <header>
    <h1>Log Files Download</h1>
  </header>
  <br/>
  <br/>
  <p>In order to help investigate any issues you may be experiencing, the Trace Helpdesk may request that you send them
    the system log files.</p>
  <br/>
  <p>These log files will only be used for the stated purpose and will be destroyed, once the investigation is
    complete.</p>
  <br/>
  <p>To download a zip file of the system logs please click here:</p>
  <div class="button-bar ui-dialog-buttonpane ui-helper-clearfix text-center">
    <button pButton [disabled]="!(enabled | async)" (click)="download()" label="Download"></button>
  </div>
  <div *ngIf="!(enabled | async)">
    <p-progressSpinner></p-progressSpinner>
  </div>
</section>
